import React, { Fragment } from 'react'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import * as dates from 'date-arithmetic'
import PropTypes from 'prop-types'
import { Table, Col } from 'reactstrap'
import moment from 'moment/moment';

import { isNull, displayDate } from '../../../izUtils'
import { handleEvent } from '../helper/handleEvent'
import { handleDay } from '../helper/handleDay'
import { tokenState } from '../../../recoil/recoil';
import holidaysArray from "../helper/holidays";

function rangeFunc(start, end, unit = 'day') {
    let current = start
    const days = []
    while (dates.lte(current, end, unit)) {
        days.push(current)
        current = dates.add(current, 1, unit)
    }
    return days
}

const isInRange = (date, task) => {
    return dates.inRange(date, task.start, task.end, 'day')
}

export const ReversedAgendaView = ({ accessors, localizer, length, date, events }) => {
    const Navigate = useNavigate()
    const token = useRecoilValue(tokenState);

    const renderTaskDay = (task, index) => {
        if (task.type === 'task') {
            let color = '#dc3545';
            let backgroundColor = 'transparent';

            if (task.serviceType.id === 'upgrade') {
                color = '#000';
            } else if (task.serviceType.id === 'flat_rate') {
                color = '#51bb25';
            }

            if (["preview"].indexOf(task.status) !== -1) {
                // If task is in the past
                if (dates.lte(task.end, dates.add(moment().toDate(), -1, 'day'), 'day')) {
                    color = '#ffcc00';
                }
            }

            if (["checkup", "in_approval", "approved"].indexOf(task.status) !== -1) backgroundColor = '#ddd'

            return (
                <div
                    style={{ color: color, backgroundColor: backgroundColor }}
                    key={'task-day-' + task.title + '-' + localizer.format(date, 'DD.MMMM') + '-' + index}
                    className="agenda-cell"
                    onClick={() => handleEvent(task, t, Navigate, token)}
                >
                    <>
                        {(
                            (!isNull(task.facility) ? task.facility.title : '/') +
                            ((!isNull(task.security_systems) && task.security_systems.length !== 0) ?
                                (' (' + task.security_systems.map(ss => ss.title) + ') ')
                                : ' /'
                            )
                        )}
                        {task.important ? t('calendar.important') + ' - ' + displayDate(task.start, 'time') : ""}
                        {!isNull(task.status) ? ' - ' + t(`status.${task.status}`) : ""}
                    </>
                </div>
            )
        } else if (task.type === 'event') {
            return <div style={{ color: '#000' }} key={'task-day-' + task.title + '-' + localizer.format(date, 'DD.MMMM') + '-' + index} className="agenda-cell" onClick={() => handleEvent(task, t, Navigate, token)}>
                {((!isNull(task.facility) ? task.facility.title : '/') + ((!isNull(task.project_number) && !isNull(task.project_number.title) && task.project_number.title.length !== 0) ? ', ' + task.project_number.title : ''))}
            </div>
        } else if (task.type === 'service') {
            return <div /*style={{ color: '#00aeef' }}*/ key={'task-day-' + task.title + '-' + localizer.format(date, 'DD.MMMM') + '-' + index} className="agenda-cell" onClick={() => handleEvent(task, t, Navigate, token)}>
                {t('calendar.service') + ': ' + (!isNull(task.task) && !isNull(task.task.facility) ? task.task.facility.title : '/') + ' - ' + task.serviceNumber}
            </div>
        } else {
            let exceptionName = (isNull(task.exception) ? '/' : t('calendar.' + task.exception));
            if (!isNull(task.exception) && task.exception === 'other') exceptionName = task.exception_name;
            return <div style={{ color: '#00aeef' }} key={'task-day-' + task.title + '-' + localizer.format(date, 'DD.MMMM') + '-' + index} className="agenda-cell" onClick={() => handleEvent(task, t, Navigate, token)}>
                {exceptionName}
            </div>
        }
    }

    const end = dates.add(date, 6, 'day')
    const range = rangeFunc(date, end, 'day')

    let techniciansDisplay = [];

    let index = 0;
    for (const tech in events) {
        // eslint-disable-next-line
        let taskRow = range.map(date => {
            const dayOfWeek = date.getDay()
            let isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0);
            if (holidaysArray.indexOf(moment(date).format('yyyy-MM-DD')) !== -1) {
                isWeekend = true;
            }
            const isToday = (moment(date).isSame(new Date(), 'day'));

            let taskDay = [];
            events[tech].calendarEvents.forEach((task, index) => {
                const inRange = isInRange(date, task);
                if (inRange) {
                    if (!isNull(task.assigned) && task.assigned.length !== 0) {
                        task.assigned.forEach((assigned, i) => {
                            const inRangeAssigned = isInRange(date, { start: assigned.from, end: assigned.to });
                            if (inRangeAssigned) {
                                taskDay.push(renderTaskDay(task, index))
                            }
                        })
                    } else {
                        taskDay.push(renderTaskDay(task, index))
                    }
                }
            })

            return (
                <tr key={'task-day-' + localizer.format(date, 'DD.MMMM') + '-' + index}>
                    <th scope="col" style={{ backgroundColor: isToday ? "#fff" : (isWeekend ? '#eee' : '#cdcdcd') }}>{localizer.format(date, 'DD.MMMM')}</th>
                    <td style={{ padding: 0, backgroundColor: isToday ? "#fff" : (isWeekend ? '#eee' : '#cdcdcd') }}>
                        <div style={{ height: '100%' }} className='d-flex flex-column'>
                            {taskDay}
                            {token.parsedToken.type !== 'technician' && (
                                <div id="clickable-agenda-area" onClick={() => handleDay(t, date, events[tech])}></div>
                            )}
                        </div>
                    </td>
                </tr>
            )
        })

        const techRow = (
            <Fragment key={"technician-row" + events[tech].id}>
                <tr>
                    <th scope="row">{t('calendar.user')}</th>
                    <td><b>{events[tech].name}</b></td>
                </tr>
                {taskRow}
            </Fragment>
        )

        techniciansDisplay.push(techRow)
        index++;
    }

    return (
        <div className="card-block row">
            <Col sm="12" lg="12" xl="12">
                <div className="table-responsive">
                    <Table className="table-responsive-sm reversed-agenda-table">
                        <tbody>
                            {techniciansDisplay}
                        </tbody>
                    </Table>
                </div>
            </Col>
        </div>
    )
}

ReversedAgendaView.title = (start, { localizer }) => {
    const end = dates.add(start, 6, 'day')
    return localizer.format({ start, end }, 'agendaHeaderFormat')
}

ReversedAgendaView.navigate = (date, action) => {
    switch (action) {
        case 'PREV':
            return dates.add(date, -7, 'day')
        case 'NEXT':
            return dates.add(date, 7, 'day')
        default:
            return date
    }
}

ReversedAgendaView.propTypes = {
    events: PropTypes.array,
    date: PropTypes.instanceOf(Date),
    length: PropTypes.number,
    selected: PropTypes.object,
    accessors: PropTypes.object.isRequired,
    components: PropTypes.object.isRequired,
    getters: PropTypes.object.isRequired,
    localizer: PropTypes.object.isRequired,
}